module.exports = __webpack_public_path__ + "static/img/fhj.c250707f.png";